/**
 * Enumeration of question types available in the form builder
 */
export enum QuestionType {
  CheckboxList = 'checkbox',
  DropdownList = 'dropdown',
  DynamicDropdown = 'dynamicdropdown',
  Email = 'email',
  Date = 'date',
  TextBox = 'textbox',
  Tel = 'tel',
  Radio = 'radio',
  TextArea = 'textarea',
  Toggle = 'toggle',
  /** A single checkbox confirming a statement — a declaration. */
  Confirmation = 'confirmation',
  HelperText = 'helpertext',
  Section = 'section',
  Title = 'title'
}

/**
 * Enumeration of option generation rules for dynamic dropdowns
 * Determines how dropdown options are sourced/generated
 */
export enum OptionGenerationRule {
  /** Options are sourced from a container element */
  SourceContainer = 'SourceContainer',
  /** Options are generated from a text property */
  TextProperty = 'TextProperty',
  /** Options use custom option IDs */
  CustomOptionId = 'CustomOptionId',
  /** Options use custom option text */
  CustomOptionText = 'CustomOptionText'
}

